import * as FieldType from './FieldConstants';

export const requiredValidation = (field) => {
  if (typeof field.value === 'string') {
    return field.value.trim() ? true : false;
  } else {
    return field.value ? true : false;
  }  
};

export const emailValidation = (field) => {
  const mailformatRegExp = new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/);
  return regexValidation(field, mailformatRegExp);
};

export const regexValidation = (field, regex) => {
  const value = field.value;
  return !value || value.length === 0 || regex.test(value);
};

export const dateValidation = (field, minValue) => {
  const value = field.value;
  if (!value || value.length === 0) {
    return true;
  }
  var dateValue = Date.parse(field.value);
  if (minValue != null && Date.parse(minValue) > dateValue) {
     return false;
  }
  var currentDate = new Date();
  return currentDate > dateValue;
};

export const zipCodeValidator = (field, minValue) => {
  const value = field.value;
  var zipCodeValue = parseInt(value, 10);
  return minValue < zipCodeValue
};

const getValidators = (field) => {
  const validators = [];
  if (field.required) {
    validators.push(requiredValidation);
  }
  if (field.regex) {
    const regex = field.regex;
    validators.push((field) => {
      return regexValidation(field, new RegExp(regex));
    });
  }
  if (field.type === FieldType.EMAIL_FIELD) {
    validators.push(emailValidation);
  }
  if (field.type === FieldType.DATE_FIELD) {
    const minValue = field.minValue;
    validators.push((field) => {
      return dateValidation(field, minValue);
    });
  }
  if(field.type === FieldType.NUMBER_FIELD) {
    const minValue = field.minValue;
    validators.push((field) => {
      return zipCodeValidator(field, minValue);
    });
  }
  return validators;
};

export default getValidators;
